import { oz, values } from '@weft/utils';

export const AGGREGATION_WITH_FIELD_OPERATORS = Object.freeze({
  Sum: 'Sum',
  Distinct: 'Distinct',
  Max: 'Max',
  Min: 'Min',
  Average: 'Average',
  First: 'First',
  Last: 'Last',
});

export const AGGREGATION_WITHOUT_FIELD_OPERATORS = Object.freeze({
  Count: 'Count',
});

export const AGGREGATION_OPERATORS = Object.freeze({
  ...AGGREGATION_WITHOUT_FIELD_OPERATORS,
  ...AGGREGATION_WITH_FIELD_OPERATORS,
});

export const AGGREGATION_METHOD_VALUES = values(AGGREGATION_OPERATORS);

export const AggregationOperatorSchema = oz.nativeEnum(AGGREGATION_OPERATORS).openapi('AggregationOperator');

export const AggregationWithFieldOperatorSchema = oz.nativeEnum(AGGREGATION_WITH_FIELD_OPERATORS).openapi('AggregationWithFieldOperator');

export const AggregationWithoutFieldOperatorSchema = oz.nativeEnum(AGGREGATION_WITHOUT_FIELD_OPERATORS).openapi('AggregationWithoutFieldOperator');

export type AggregationOperator = oz.infer<typeof AggregationOperatorSchema>;